import { render, staticRenderFns } from "./MultiInputItem.vue?vue&type=template&id=0136262d&scoped=true&"
import script from "./MultiInputItem.vue?vue&type=script&lang=js&"
export * from "./MultiInputItem.vue?vue&type=script&lang=js&"
import style0 from "./MultiInputItem.vue?vue&type=style&index=0&id=0136262d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136262d",
  null
  
)

export default component.exports